import React, { type FC } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { type Notice } from '../../../redux/notices/notices-types'
import { MarkNoticeAsReadAction } from '../../../redux/notices/notices-actions'
import { useTranslation } from 'react-i18next'
import { type RootState } from '../../../redux/store'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { formatEpochSecondsToTimestamp } from '../../../utils/utils'

/**
 * Unread notice component.
 */
export const UnreadNotice: FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const notices = useAppSelector<Notice[]>((state: RootState): Notice[] => state.notices.notices)
  const unreadNotice = notices.find((notice) => !notice.readByUser)

  const markAsRead = (id: string): void => {
    dispatch(MarkNoticeAsReadAction(id))
  }

  if (unreadNotice == null) {
    return <></>
  }

  const createdAtLabel: string = t('notices.created')
  const createdAtValue: string = formatEpochSecondsToTimestamp(unreadNotice.createdAt)

  return <Dialog
        fullWidth
        maxWidth="md"
        open={true}
    >
        <DialogTitle>
            <b>{t('notices.unreadNotice')}</b>
        </DialogTitle>

        <DialogContent>
            <p style={{ whiteSpace: 'pre' }}>{unreadNotice.content}</p>
        </DialogContent>

        <DialogActions style={{ justifyContent: 'space-between' }}>
            <Typography style={{ color: 'gray' }}>
                {createdAtLabel} {createdAtValue}
            </Typography>
            <Button
                variant='contained'
                onClick={() => {
                  markAsRead(unreadNotice.id)
                }}
            >
                <Typography>{t('notices.markAsRead')}</Typography>
            </Button>
        </DialogActions>
    </Dialog>
}
